import { render, staticRenderFns } from "./ResetKycConfirmationDialog.vue?vue&type=template&id=418d1c0b"
import script from "./ResetKycConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ResetKycConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports